import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import {Provider} from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'

import App from './App/index';
import * as serviceWorker from './serviceWorker';
import config from './config';
import store  from './store/index';

const instance = createInstance({
    urlBase: "https://analytics.avantis.co.in/",
    siteId: 3 // optional, default value: `1`    
});

const app = (
    <Provider store={store}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            {/* basename="/datta-able" */}
            <MatomoProvider value={instance}>
                <App />
            </MatomoProvider>
        </BrowserRouter>
    </Provider>
);



ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
